import { z } from 'zod';
import { createRequestEnumPreprocessor } from '../../../utils/create-request-enum-preprocessor';
import { coPilotOptionsSchema } from './copilot-options.schema';
import { displayRestrictionTypeOptions } from './display-restriction-type.schema';
import { ferriesOptions } from './ferries.schema';
import { hazmatTypeOptions } from './hazmat-type.schema';
import { routingOptionsSchema } from './routing-options.schema';
import { routingProfileSchema } from './routing-profile.schema';
import { routingTypeOptions } from './routing-type.schema';
import { tollRoadTypeOptions } from './toll-road-type.schema';
import { tunnelCategoryOptions } from './tunnel-category.schema';
import { unitsOfMeasurementOptions } from './units-of-measurement.schema';
import { vehicleOptionsSchema } from './vehicle-options.schema';
import { sideOfStreetAdherenceLevelOptions } from './side-of-street-adherence-level.schema';

/**
 * These Schemas should not be used outside data-access. These are utility schemas to process values before making API calls such as when transforming enums from strings to numbers.
 */

export const routingProfileRequestSchema = routingProfileSchema.extend({
  routingProfileId: z.number().optional(),
  units: createRequestEnumPreprocessor(unitsOfMeasurementOptions),
  copilotOptions: coPilotOptionsSchema
    .extend({
      displayRestrictions: createRequestEnumPreprocessor(
        displayRestrictionTypeOptions
      ),
    })
    .optional(),
  routingOptions: routingOptionsSchema
    .extend({
      ferries: createRequestEnumPreprocessor(ferriesOptions),
      tollRoads: createRequestEnumPreprocessor(tollRoadTypeOptions),
      routeType: createRequestEnumPreprocessor(routingTypeOptions),
      sideOfStreetAdherenceLevel: createRequestEnumPreprocessor(
        sideOfStreetAdherenceLevelOptions
      ),
    })
    .optional(),
  vehicleOptions: vehicleOptionsSchema
    .extend({
      hazmatType: createRequestEnumPreprocessor(hazmatTypeOptions).optional(),
      tunnelCategory: createRequestEnumPreprocessor(
        tunnelCategoryOptions
      ).optional(),
    })
    .optional(),
});
